import ServiceDetail from '@/components/feature/ServiceDetail';

export default function HostingPage() {
  return <ServiceDetail slug="hosting" />;
}